import { Box, HStack, Icon, Flex } from '@chakra-ui/react';
import { useRef } from 'react';
import { useInViewport } from 'react-in-viewport';
import { IoIosArrowForward } from 'react-icons/io';

import { Order as MobileOrderFilter } from 'components/molecules/jobs/filters/mobile/order';
import { Salary as MobileSalaryFilter } from 'components/molecules/jobs/filters/mobile/salary';
import { Seniority as MobileSeniorityFilter } from 'components/molecules/jobs/filters/mobile/seniority';
import { Technologies as MobileTechnologiesFilter } from 'components/molecules/jobs/filters/mobile/technologies';
import { Remote as MobileRemoteFilter } from 'components/molecules/jobs/filters/mobile/remote';
import { Focus as MobileFocusFilter } from 'components/molecules/jobs/filters/mobile/focus';
import { Advanced as MobileAdvancedFilter } from 'components/molecules/jobs/filters/mobile/advanced';
import { MobileCompanyLocationFilter } from 'components/molecules/jobs/filters/mobile/companyLocation';

export interface MobileFiltersProps {
  handleSearchJobs(): void;
  defaultSalaryValues: Array<number>;
  showOrderFilter: boolean;
}

export const MobileFilters = ({
  defaultSalaryValues,
  showOrderFilter,
  handleSearchJobs,
}: MobileFiltersProps) => {
  const fadeOpacityLeft = useRef<HTMLDivElement>(null);
  const fadeOpacityRight = useRef<HTMLDivElement>(null);
  const { inViewport: inViewportLeft, leaveCount } = useInViewport(
    fadeOpacityLeft,
    {},
    { disconnectOnLeave: false }
  );
  const { inViewport: inViewportRight } = useInViewport(
    fadeOpacityRight,
    {},
    { disconnectOnLeave: false }
  );

  const handleClick = () => {
    fadeOpacityRight.current?.scrollIntoView({
      inline: 'center',
      block: 'end',
      behavior: 'smooth',
    });
  };

  return (
    <Flex alignItems='center'>
      <HStack
        gap={0.5}
        overflowX='scroll'
        sx={{
          scrollbarWidth: 'none',
          '::-webkit-scrollbar': { display: 'none' },
          Mask: `${
            !inViewportLeft
              ? 'linear-gradient(to left, #fff 90%, transparent)'
              : ''
          }${!inViewportLeft && !inViewportRight ? ',' : ''}${
            !inViewportRight
              ? 'linear-gradient(to right, #fff 90%, transparent)'
              : ''
          }`,
          '-webkit-mask': `${
            !inViewportLeft
              ? 'linear-gradient(to left, #fff 90%, transparent)'
              : ''
          }${!inViewportLeft && !inViewportRight ? ',' : ''}${
            !inViewportRight
              ? 'linear-gradient(to right, #fff 90%, transparent)'
              : ''
          }`,
        }}
      >
        <Box mr='-8px' ref={fadeOpacityLeft} />
        <MobileCompanyLocationFilter handleSearchJobs={handleSearchJobs} />
        <MobileFocusFilter handleSearchJobs={handleSearchJobs} expands />
        <MobileTechnologiesFilter handleSearchJobs={handleSearchJobs} />
        <MobileRemoteFilter handleSearchJobs={handleSearchJobs} />
        <MobileSeniorityFilter handleSearchJobs={handleSearchJobs} />

        <MobileSalaryFilter
          defaultSalaryValues={defaultSalaryValues}
          handleSearchJobs={handleSearchJobs}
        />

        <MobileAdvancedFilter
          defaultSalaryValues={defaultSalaryValues}
          handleSearchJobs={handleSearchJobs}
        />

        {showOrderFilter ? <MobileOrderFilter /> : null}

        <Box
          data-testid='filters-right-edge'
          w='1px'
          ml='-7px'
          flexShrink='0'
          ref={fadeOpacityRight}
        />
      </HStack>
      {!inViewportRight && leaveCount === 0 ? (
        <Icon
          data-testid='arrow-icon'
          as={IoIosArrowForward}
          position='absolute'
          right='8px'
          color='primary.500'
          boxSize='20px'
          onClick={handleClick}
        />
      ) : null}
    </Flex>
  );
};
